import { useBrowserSpecs } from './useBrowserSpecs';

const iphone = () => {
  const { isIphone } = useBrowserSpecs();
  return isIphone ? '' : '@media not all';
};

const min = (size) => {
  return (props) => `@media (min-width: ${props.theme?.breakpoints[size]}px)`;
};

const portrait = () => {
  return `@media (orientation: portrait)`;
};

const landscape = () => {
  return `@media (orientation: landscape)`;
};

export default {
  iphone,
  min,
  portrait,
  landscape,
};
